module.exports = ".dropdown-menu-left {\r\n    left: auto !important;\r\n    right: 24px !important;\r\n    top: -90px !important;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-content/content-container/port-call/overview/button-row/button-row.component.css
// module id = ./src/app/main-content/content-container/port-call/overview/button-row/button-row.component.css
// module chunks = main